import { transport } from 'config/transport';

export function callApiSaveThuCongDoanVung(congdoanvungId, month, year, body) {
    return transport.post(`/congdoanvung/${congdoanvungId}/thuchi/thucongdoanvung`, body, { params: { month, year } });
}
